// ════════════════════════════════════════════════════════════════
// MAIN — Entry point + Smart Ad-Free Visibility Check
// ════════════════════════════════════════════════════════════════
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// ── Visual Ad Control System ──
// Check if they just returned from a successful Stripe purchase link
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('premium') === 'true') {
  localStorage.setItem('user_is_premium', 'true');
}

// Read the browser memory key to decide whether to draw ads or keep it clean
const isPremiumUser = localStorage.getItem('user_is_premium') === 'true';

if (!isPremiumUser) {
  // Inject AdSense ONLY if they haven't purchased the app
  const script = document.createElement('script');
  script.async = true;
  script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5578236440831548";
  script.crossOrigin = "anonymous";
  document.head.appendChild(script);
} else {
  console.info('[AdControl] Premium user detected visually. Suppressing all ads.');
}

// ── Service Worker Registration ──
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('./sw.js')
      .then((registration) => {
        console.info('[SW] Registered with scope:', registration.scope);
      })
      .catch((err) => {
        console.warn('[SW] Registration failed:', err);
      });
  });
}

// ── Render App ──
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
